import { IconFilterList } from "@/assets/icons";
import { IconSort } from "@/assets/icons/IconSort";
import { SORTING } from "@/constants/sorting";
import { black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Stack } from "@mui/material";

type TLocalTableSortingProps = {
  name: string;
  currentSort?: string;
  onSort: (sortKey: string) => void;
};

/**
 * Local state-based table sorting component (doesn't modify URL)
 * Use this in modals or places where URL-based sorting is not desired
 */
export const LocalTableSorting: FCC<TLocalTableSortingProps> = ({ name, currentSort, onSort, children }) => {
  const isCurrentlySelected = currentSort?.startsWith(name);
  const isAsc = currentSort?.includes(SORTING.ASC);
  const isDesc = currentSort?.includes(SORTING.DESC);

  const handleSort = () => {
    let newSort = "";

    if (isAsc) {
      newSort = `${name}|${SORTING.DESC}`;
    } else if (isDesc) {
      newSort = "";
    } else {
      newSort = `${name}|${SORTING.ASC}`;
    }

    onSort(newSort);
  };

  return (
    <Stack
      direction="row"
      gap={1.25}
      onClick={handleSort}
      sx={{
        cursor: "pointer",
      }}
    >
      {children}
      {isCurrentlySelected ? (
        <IconSort style={isAsc ? { transform: "rotate(180deg)" } : undefined} fontSize={24} />
      ) : (
        <IconFilterList fontSize={24} color={black[80]} />
      )}
    </Stack>
  );
};
